import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export const exportToPDF = async (elementId, filename) => {
    const input = document.getElementById(elementId);
    if (!input) {
        console.error(`Element with ID ${elementId} not found`);
        return;
    }

    // Add a temporary class to potentially adjust styles for printing if needed
    input.classList.add('pdf-export-mode');

    try {
        // Use html2canvas to capture the element
        const canvas = await html2canvas(input, {
            scale: 2, // Higher scale for better quality
            useCORS: true, // Handle cross-origin images if any
            logging: false,
            backgroundColor: '#f8fafc', // match the admin background usually
        });

        const imgData = canvas.toDataURL('image/png');
        
        // Calculate PDF dimensions
        // We want to fit it on A4 or similar, or just create a custom size that matches the canvas.
        // Usually, capturing dashboards looks best with custom sizing that matches the dashboard ratio.
        const pdf = new jsPDF({
            orientation: canvas.width > canvas.height ? 'landscape' : 'portrait',
            unit: 'px',
            format: [canvas.width, canvas.height]
        });

        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
        pdf.save(`${filename}.pdf`);
    } catch (error) {
        console.error("Failed to generate PDF", error);
        alert("Failed to generate PDF. Please try again.");
    } finally {
        input.classList.remove('pdf-export-mode');
    }
};
